import urlConfig from 'Url';

export const GET_REFUND_COUPONS = 'GET_REFUND_COUPONS';
export const SELECT_REFUND_COUPON = 'SELECT_REFUND_COUPON';
export const CANCEL_REFUND_COUPON = 'CANCEL_REFUND_COUPON';
export const INIT_REFUND_COUPON = 'INIT_REFUND_COUPON';

export function selectCoupon(code, psgSegmentData, couponData) {
  return {
    type: SELECT_REFUND_COUPON,
    code,
    psgSegmentData,
    couponData,
  };
}

export function cancelCoupon(code) {
  return {
    type: CANCEL_REFUND_COUPON,
    couponCode: code,
  };
}

export function getCoupons(data, charge, refundWay) {
  return {
    type: GET_REFUND_COUPONS,
    closeLoading: true,
    psgsCharge: charge,
    refundWay: refundWay,
    payload: {
      request: {
        url: urlConfig.touchRefundSearchBGQ,
        method: 'post',
        data,
      },
    },
  };
}

export function clearRefundCoupon() {
  return {
    type: INIT_REFUND_COUPON,
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/refundCoupon/modules/actions.js